import React from "react";
import style from "./index.module.scss";
import CustomEmpty from "components/CourseComponents/CustomEmpty";

interface SubEmptyProps {
    onAdd: () => void;
}

export default function SubEmpty({ onAdd }: SubEmptyProps) {
    return (
        <CustomEmpty
            description={
                <button type="button" className={style.add} onClick={onAdd}>
                    添加小题
                </button>
            }
        />
    );
}
